/**
 * AiImageNote — the small "this picture was generated" line under a product photo.
 *
 * WHY IT EXISTS
 * -------------
 * The catalogue photos are AI-generated rather than photographs of the actual
 * stock. A student deciding what to buy should be told that by the picture
 * itself, at the moment they are looking at it — not in a policy page nobody
 * opens. It is a disclosure, so it is always visible and never dismissible.
 *
 * ONLY RENDER IT WHERE THERE IS A GENERATED IMAGE.
 * Every product falls back to an emoji when it has no photo (or the photo
 * 404s), and an emoji is not an AI-generated image. Labelling one would be a
 * false statement, which is worse than saying nothing — so each caller passes
 * the note only on the branch that actually rendered an <img>.
 *
 * Deliberately quiet: `text-[10px]` muted, no border, no background. It has to
 * survive on a one-third-width tile on a 360px phone without competing with
 * the product name or the Add button, which are what the student came for.
 */

import { Sparkles } from 'lucide-react';
import { cn } from '@/lib/cn';

export function AiImageNote({ label = 'AI-generated image', className }) {
  return (
    <p
      className={cn(
        'flex items-center justify-center gap-1 text-[10px] leading-tight text-muted',
        className,
      )}
    >
      <Sparkles size={10} className="shrink-0" aria-hidden="true" />
      {/*
        Wraps, never truncates. On a one-third-width tile "AI-generated image"
        clipped to "AI-generated im…", and a disclosure that gets cut off in
        the middle is worse than one that takes a second line.
      */}
      <span>{label}</span>
    </p>
  );
}

export default AiImageNote;
